import { Fragment } from 'react';

import EditIcon from '@usas/ui-web/components/icons/EditIcon';
import HideIcon from '@usas/ui-web/components/icons/HideIcon';
import ShowIcon from '@usas/ui-web/components/icons/ShowIcon';
import DeleteIcon from '@usas/ui-web/components/icons/DeleteIcon';

import { formatDate } from '@usas/ui-web/utils/DateFunctions';
import Constants from '@usas/ui-web/utils/Constants';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const DetailTableRow = ({ roles }) => (
  <tr>
    <td>{roles.goodStandingName || ''}</td>
  </tr>
);

const GridRowDetailTable = ({ course }) => (
  <table className={global.DetailTable}>
    <thead>
      <tr>
        <th>Good Standing Types</th>
      </tr>
    </thead>
    <tbody>
      {Array.isArray(course.goodStandingType) && course.goodStandingType.map((roles, i) => <DetailTableRow key={i} roles={roles} />)}
    </tbody>
  </table>
);

const GridRow = ({ course, onEditRequirement, formState, onOpenDeleteEnrollmentModal, expandedId, onClick }) => {
  const courseGoodStandingRole = Array.isArray(course.goodStandingType)
    ? course.goodStandingType.find(x => x.goodStandingName === formState.goodStandingName)
    : null;

  return (
    formState.goodStandingName === courseGoodStandingRole?.goodStandingName
      ? <Fragment>
        <tr>
          <td>{course.courseName} {course.courseCode ? `(${course.courseCode})` : ''}</td>
          <td>{course.courseCompletionDate !== null && course.coursePassed === true
            ? formatDate(course.courseCompletionDate) === Constants.DEFAULT_MAX_DATE
              ? ' '
              : formatDate(course.courseCompletionDate)
            : ' '
          }</td>
          <td>
            {course.courseExpirationDate !== null && course.coursePassed === true
              ? formatDate(course.courseExpirationDate) === Constants.DEFAULT_MAX_DATE
                ? `Doesn't Expire`
                : formatDate(course.courseExpirationDate)
              : ' '
            }
          </td>
          <td>
            {course.status}
          </td>
          <td>
            {course.hasExemption == true ? 'Yes' : ''}
          </td>
          <td>
            <span className={course.canHqEdit === true && onEditRequirement && !course.certificationId ? global.DisplayComponent : global.HideComponent}>
              <button className={global.IconButtonMargin}
                type="button" onClick={(e) => onEditRequirement(e, course)}><EditIcon /></button>
            </span>
            <span className={course.canHqEdit === true && !course.certificationId && course.status !== 'Not Completed' ? global.DisplayComponent : global.HideComponent}>
              <button className={global.IconButtonMargin} type="button" onClick={(e) => onOpenDeleteEnrollmentModal(e, course)}><DeleteIcon /></button>
            </span>
            <button
              className={global.IconButton}
              type="button"
              onClick={(e) => onClick(e, course.lmsCourseId)}>
              {expandedId === course.lmsCourseId ? <HideIcon /> : <ShowIcon />}
            </button>
          </td>
        </tr>
        {expandedId === course.lmsCourseId &&
          <tr className={global.Expanded}>
            {Array.isArray(course.goodStandingType) && course.goodStandingType.length > 0
              && <td colSpan="6">
                <GridRowDetailTable course={course} />
              </td>
            }
          </tr>}
      </Fragment>
      : <Fragment />
  );
};

const MemberRequirementsAdvancedLargeWriteGrid = ({ gridData, isLoading, onEditRequirement, formState, onOpenDeleteEnrollmentModal, expandedId, onClick }) => (
  <table className={[global.UsasTable, 'visible-md visible-lg'].join(' ')}>
    <thead>
      <tr>
        <th>Requirement</th>
        <th>Date Completed</th>
        <th>Expiration Date</th>
        <th>Status</th>
        <th>Has Exemption</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      {isLoading === true
        ? <tr><td colSpan="6">Loading...</td></tr>
        : Array.isArray(gridData) && gridData.length > 0
          ? gridData.map((course, i) =>
            <GridRow
              key={i}
              course={course}
              onEditRequirement={onEditRequirement}
              formState={formState}
              onOpenDeleteEnrollmentModal={onOpenDeleteEnrollmentModal}
              expandedId={expandedId}
              onClick={onClick} />
          )
          : <tr><td colSpan="6">No Requirements</td></tr>
      }
    </tbody>
  </table>
);

export default MemberRequirementsAdvancedLargeWriteGrid;